const goFullScreen = () => {
  document.body.requestFullscreen();
  // const elem = document.documentElement;
  // if (elem.requestFullscreen) {
  //   elem.requestFullscreen();
  // } else if (elem.webkitRequestFullscreen) {
  //   elem.webkitRequestFullscreen();
  // } else if (elem.msRequestFullscreen) {
  //   elem.msRequestFullscreen();
  // }
};

export const Fullscreen = () => {
  return (
    <div className='absolute h-full w-full h-max-full w-max-full'>
      <div className='h-full w-full flex justify-center items-center p-6'>
        <button
          className='h-12 text-gray-900 xs:block rounded-md bg-amber-400 px-4 py-1.5 text-sm font-bold shadow-sm hover:bg-amber-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600'
          onClick={goFullScreen}
        >
          Go Full Screen
        </button>
      </div>
    </div>
  );
};
